export function init($name = '') {
    const button = $($name);

    if (!button.length) {
        return;
    }

    button.click(function(e) {
        e.preventDefault();

        $(this).parents($name + '-parent').find($name + '-form').slideDown();
        $(this).parents($name + '-parent').find($name + '-news').slideUp();

        $('html, body').animate({scrollTop: 0}, 500);

        $(this).parents($name + '-parent').find($name + '-close').fadeIn();
        button.fadeOut();
    });

    button.parents($name + '-parent').find($name + '-close').click(function(e) {
        e.preventDefault();

        $(this).parents($name + '-parent').find($name + '-form').slideUp();
        $(this).parents($name + '-parent').find($name + '-news').slideDown();
        $('html, body').animate({scrollTop: 0}, 500);

        $(this).parents($name + '-parent').find($name + '-close').fadeOut();
        button.fadeIn();
    });
}